// https://szhsin.github.io/react-menu-v2

import * as React from 'react';
import {
  Menu,
  MenuItem,
  MenuButton
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import '../css/postMenu.css';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import '@sweetalert2/themes/dark';
import moment from 'moment';
import 'weather-react-icons/lib/css/weather-icons.css';
import { WeatherIcon } from 'weather-react-icons';
import { IconContext } from "react-icons";
import { FaTemperatureHalf } from "react-icons/fa6";
import { MdMyLocation } from "react-icons/md";
import { FaWind } from "react-icons/fa";
import { FaGaugeHigh } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { TiWeatherSunny } from "react-icons/ti";
import { renderToString } from 'react-dom/server';
import { table } from 'console';

export default function PostMenu(props: any, ref: any) {
  var strURL = 'https://api.chonerman.com/commenter';

  // Delete
  const deletePost = async (id: string) => {
    let requestOptions = {
      headers: {
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'X-API-Key': '1m7eHtTtkU83F8lBV81D6alTgJXF0A8o7Apfqa8r',
        'Content-Type': 'application/json'
      }
    };

    let data = {
      'Authorization': 'X-API-KEY'
    };

    var delPost = document.getElementById(id)!;
    delPost.className = "delBox";

    try {
      console.log("Deleting: " + id, "💨");
      var response = await axios.put(strURL + "?tblName=" + props.table + "&_id=" + id, data, requestOptions);
      if (response.status === 200) {
        console.log("Deleted: " + id, "❌");
        ref.current?.scrollIntoView({
          behavior: 'smooth'
        });
        return response.data;
      } else {
        console.log("Error: " + response.data, "");
        return;
      }
    } catch (error) {
      console.error("Error: " + error, "💥");
      console.error("Error info: " + error, "💥");
    }

  };

  // Weather
  const weatherPost = async (id: string) => {
    let requestOptions = {
      headers: {
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'X-API-Key': '1m7eHtTtkU83F8lBV81D6alTgJXF0A8o7Apfqa8r',
        'Content-Type': 'application/json'
      }
    };

    /*     let data = {
          'Authorization': 'X-API-KEY'
        }; */

    /*     var delPost = document.getElementById(id)!;
        delPost.className = "delBox"; */

    try {
      console.log("Fetching weather " + id, "💨");
      var response = await axios.get(strURL + "?_id=" + id, requestOptions);
      if (response.status === 200) {
        //console.log("Deleted: " + id, "❌");
        //ref.current?.scrollIntoView();
        return response.data;
      } else {
        console.error("Error: " + response.data, "");
        return;
      }
    } catch (error) {
      console.error("Error: " + error, "💥");
      console.error("Error info: " + error, "💥");
    }

  };

  const handleWeatherClick = async (e: any) => {
    let postID = e.syntheticEvent.target.id;
    //let postWeather = await weatherPost(postID.substr(8));
    let postWeather = props.weather;
    //console.log(postWeather.weather.location);
    let strName = postWeather.name;
    let strDT = postWeather.postdt;
    let numLat = postWeather.lat;
    let numLong = postWeather.long;
    let strIcon = 800;
    if (typeof (postWeather.weather.icon) === 'number') {
      strIcon = postWeather.weather.icon;
    } else {
      strIcon = 800;
    }
    let strIconComp = <WeatherIcon className="wIcons2" iconId={strIcon} name="owm" />
    let strTemp = postWeather.weather.temp;
    let strLoc = postWeather.weather.location;
    //let strWeather = postWeather.weather.weather;
    let strHumidity = postWeather.weather.humidity;
    let strPressure = postWeather.weather.pressure;
    let strWind = postWeather.weather.wind;
    let strSunrise = "?";
    if (typeof postWeather.weather.sunrise !== "undefined") {
      strSunrise = postWeather.weather.sunrise;
    }
    let strSunset = "?";
    if (typeof postWeather.weather.sunset !== "undefined") {
      strSunset = postWeather.weather.sunset;
    }
    //let intSunrise = postWeather[0].sys.sunrise;
    //let intSunset = postWeather[0].sys.sunset;
    //https://sweetalert2.github.io/#usage
    var coordLink = 'https://www.google.com/maps/place/' + numLat + ',' + numLong;
    const innerWeather =
      <IconContext.Provider value={{ color: "rgb(119, 148, 255)", size: "1.3em" }}>
        <div className='weather-info'>

          <div className='icon1'><MdMyLocation /></div>
          <div className='loc'>{strLoc}&nbsp;&nbsp;&nbsp;&nbsp;
            <span className='coords'>
              <a href={coordLink} target='_blank' rel="noreferrer">{numLat ? numLat?.toFixed(3) : "?"}, {numLong ? numLong?.toFixed(3) : "?"}</a>
            </span>
          </div>

          <div className='icon1'><FaTemperatureHalf /></div>
          <div className='desc2'>{strTemp}</div>

          <div className='icon3'><FaWind /></div>
          <div className='desc4'>{strWind}</div>

          <div className='icon1'><i className="wi wi-humidity wIcons2"></i></div>
          <div className='desc2'>{strHumidity}</div>

          <div className='icon3'><FaGaugeHigh /></div>
          <div className='desc4'>{strPressure}</div>

          <div className='icon1'><i className="wi wi-sunrise wIcons2"></i></div>
          <div className='desc2'>{strSunrise}</div>

          <div className='icon3'><i className="wi wi-sunset wIcons2"></i></div>
          <div className='desc4'>{strSunset}</div>
        </div>
      </IconContext.Provider>
      ;
    Swal.fire({
      title: strName,
      html: renderToString(innerWeather),
      icon: "info",
      iconHtml: renderToString(strIconComp),
      footer: moment(strDT).format('lll'),
      confirmButtonText: 'close'
    });
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Feature Not Done!",
      html: "The edit functionality is not complete yet.",
      icon: "info",
      confirmButtonText: 'close',
      toast: true
    });
  };

  const handleDeleteClick = (e: any) => {
    let postID = e.syntheticEvent.target.id;
    //console.log(postID.substr(4));
    Swal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result: { isConfirmed: any; isDenied: any; }) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deletePost(postID.substr(4));
        Swal.fire({
          title: "Deleted!",
          html: "Post ID: " + postID.substr(4),
          icon: "success",
          toast: true
        });
      }
    });
  };

  return (
    <>

      <Menu menuButton={<MenuButton className="post-menu-btn">⋮</MenuButton>}
        direction="left" align="start" position="anchor"
        arrow={true} viewScroll="close" portal={false}
        menuClassName="post-menu" transition>
        <MenuItem className="post-menu-item" onClick={handleWeatherClick} id={"weather-" + props.post}>
          <IconContext.Provider value={{ color: "yellow", size: "1.3em" }}>
            <TiWeatherSunny />&nbsp;&nbsp;Info
          </IconContext.Provider>
        </MenuItem>
        <MenuItem className="post-menu-item" onClick={handleEditClick} id={"edit-" + props.post}>
          <IconContext.Provider value={{ color: "gray", size: "1.3em" }}>
            <FaRegEdit />&nbsp;&nbsp;Edit
          </IconContext.Provider>
        </MenuItem>
        <MenuItem className="post-menu-item" onClick={handleDeleteClick} id={"del-" + props.post}>
          <IconContext.Provider value={{ color: "red", size: "1.3em" }}>
            <MdDeleteForever />&nbsp;&nbsp;Delete
          </IconContext.Provider>
        </MenuItem>
      </Menu>
    </>
  );
}